/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-props-no-spreading */
import { useState, useEffect, useCallback } from "react";
import { Route, withRouter, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Badge,
  Box,
  Checkbox,
  Fade,
  OutlinedInput,
  Paper,
  makeStyles,
  MenuItem,
  Tab,
  Tabs,
  Typography,
  Select,
  CircularProgress,
} from "@material-ui/core";
import dayjs from "dayjs";
import Skeleton from "@material-ui/lab/Skeleton";
import HorizontalProgress from "../common/AMChart/HorizontalProgressBar";
import MainContent from "../common/MainContent";
import ReusableChart from "../common/AMChart/AMChart";
import BreakDownBar from "../common/AMChart/BreakDownBar";
import { apiService } from "../../services/apiService";
import { withGatewayApi } from "../../API";
import noResultImg from "../../images/no-result.svg";
import { setEventSummary } from "../../redux/Actions";
import getDateRange from "../../utils/dateRange";
import moveClicksLast from "../../utils/moveClicksLast";

const Reporting = ({ history }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [activeTab, setActiveTab] = useState(
    Number(params.get("activeGroupIndex")) || 0
  );
  // const [runOnLoad, setRunOnLoad] = useState(true);
  const [eventDetail, setEventDetail] = useState([]);
  const [visible, setVisible] = useState(false);
  const [businessList, setBusinessList] = useState(null);
  const [selectedBusiness, setSelectedBusiness] = useState({
    business_id: "",
    business_name: "All business names",
  });
  const [dateRange, setDateRange] = useState(Number(params.get("period")) || 1);
  const [isBreakdownReport, setIsBreakdownReport] = useState(
    JSON.parse(params.get("isBreakdownReport") || false)
  );
  const [selectedDate, setSelectedDate] = useState(
    getDateRange(dateRange, "event-detailed")
  );
  // eslint-disable-next-line no-unused-vars
  const [queryParams, setQueryParams] = useState({
    period: null,
    activeGroupIndex: null,
    isBreakdownReport: false,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isEventDetailLoading, setiIsEvetnDetailLoading] = useState(false);
  const user = useSelector((state) => state.session.user);
  const eventSummary = useSelector((state) => state.eventSummary);
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const hasKey = params.has("isBreakdownReport");
    const value = params.get("isBreakdownReport");
    // console.log(hasKey && value);
    if (hasKey && value) {
      // params.set("isBreakdownReport", false);
      // setIsBreakdownReport(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const handleChange = (event, newValue) => {
    if (newValue === activeTab) return;
    setActiveTab(newValue);
    params.set("period", dateRange);
    params.set("activeGroupIndex", newValue);
    params.set("isBreakdownReport", false);
    history.push({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  const fetchBusinessNames = useCallback(async () => {
    try {
      const response = await apiService.get("catcher/get-business-names", {
        id: user.contact.customerNumber,
      });
      setBusinessList(response.Data.businesses);
    } catch (err) {
      console.log(err);
    }
  }, [user]);

  const fetchEventSummary = useCallback(async () => {
    if (user) {
      try {
        setIsLoading(true);
        const response = await apiService.get("catcher/event-summary", {
          ...selectedDate,
          include_rli: isBreakdownReport,
          cid: user.contact.customerNumber,
        });
        if (response.Data?.success === false) {
          dispatch(
            setEventSummary(
              moveClicksLast([
                {
                  event_group_code: "group-4",
                  event_group_name: "calls",
                  total: 0,
                },
                {
                  event_group_code: "group-3",
                  event_group_name: "digital contacts",
                  total: 0,
                },
                {
                  event_group_code: "group-1",
                  event_group_name: "views",
                  total: 0,
                },
                {
                  event_group_code: "group-2",
                  event_group_name: "clicks",
                  total: 0,
                },
              ])
            )
          );
        } else {
          dispatch(setEventSummary(moveClicksLast(response.Data.event_groups)));
        }

        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
      }
    }
  }, [dispatch, isBreakdownReport, selectedDate, user]);

  const activeEvent = eventSummary?.[activeTab];
  const fetchEventDetail = useCallback(async () => {
    if (!activeEvent) return;
    try {
      const response = await apiService.get("catcher/event-detailed", {
        ...selectedDate,
        event_group_code: eventSummary[activeTab].event_group_code,
        cid: user.contact.customerNumber,
        ...(selectedBusiness?.business_id && {
          business_id: selectedBusiness.business_id,
        }),
      });
      dispatch(setEventDetail(response.Data.service_types));
      setiIsEvetnDetailLoading(false);
    } catch (err) {
      setiIsEvetnDetailLoading(false);
    }
    // eslint-disable-next-line prettier/prettier
  }, [
    selectedDate,
    activeTab,
    activeEvent?.event_group_code,
    selectedBusiness.business_id,
  ]);

  useEffect(() => {
    if (user) {
      fetchBusinessNames();
    }
  }, [fetchBusinessNames, user]);

  useEffect(() => {
    (async () => {
      setiIsEvetnDetailLoading(true);
      await fetchEventSummary();
      await fetchEventDetail();
    })();
  }, [fetchEventSummary, fetchEventDetail]);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleDateRange = (e) => {
    setDateRange(e.target.value);
    setSelectedDate(getDateRange(e.target.value, "event-detailed"));
    params.set("period", e.target.value);
    history.push({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  const handleBusinessName = (e) => {
    const selectedId = e.target.value;

    if (selectedId === "") {
      // "All business names" selected
      setSelectedBusiness({
        business_id: "",
        business_name: "All business names",
      });
      return;
    }

    const selectedItem = businessList.find(
      (item) => item.business_id === selectedId
    );

    setSelectedBusiness(selectedItem || null);
  };

  const useStyles = makeStyles({
    customInput: {
      "& .MuiSelect-select:focus": {
        backgroundColor: "transparent",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "gray",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "gray",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "gray",
      },
    },
    flexBox: {
      display: "flex",
      justifyContent: "space-between", // pushes left/right
      alignItems: "center", // vertical alignment
    },
    downloadLink: {
      fontWeight: "bold",
      color: "#374953",
      textDecoration: "none",
      cursor: "pointer",
      "&:hover": {
        color: "#50636d",
      },
    },
    breakdownButton: {
      color: "#374953",
      fontWeight: "bold",
      fontSize: "20px",
      textDecoration: "underline",
      cursor: "pointer",
      "&:hover": {
        color: "#50636d",
      },
    },
    BreakDownText: {
      fontWeight: "bolder",
      fontSize: "2rem",
      letterSpacing: "-2px",
    },
    volatile: {
      width: "1rem",
      height: "1rem",
      borderRadius: "50%",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "0.625rem",
      lineHeight: 1,
      backgroundColor: "#dddddd",
      verticalAlign: "middle",
      marginBottom: "2px",
    },
    downloadCsv: {
      backgroundColor: "transparent",
      border: "none",
      fontWeight: "bold",
      color: "#374953",
      cursor: "pointer",
      "&:hover": {
        color: "#50636d",
      },
    },
  });

  const handleDownloadCsv = (data, serviceName, groupEventName) => {
    const headers = ["date", serviceName];
    const rows = data.map((item) => [item.period, item.total]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${groupEventName}_service_trends.csv`;
    link.click();

    // Clean up
    URL.revokeObjectURL(url);
  };

  const classes = useStyles();
  return (
    <MainContent header="My Reporting" description="">
      <>
        {isBreakdownReport ? (
          <Box>
            <Typography
              component="button"
              style={{
                marginBottom: 30,
                padding: 0,
                fontWeight: "bold",
                border: "none",
                backgroundColor: "transparent",
                color: "#374953",
                cursor: "pointer",
              }}
              onClick={() => {
                params.set("isBreakdownReport", false);
                setIsBreakdownReport(false);
                history.push({
                  pathname: location.pathname,
                  search: params.toString(),
                });
              }}
            >
              {"< Back"}
            </Typography>
          </Box>
        ) : null}
        <Box
          display="flex"
          justifyContent={isBreakdownReport ? "space-between" : "flex-end"}
          alignItems="base-line"
          style={{ marginBottom: 20 }}
        >
          {!isBreakdownReport ? (
            <Select
              value={selectedBusiness?.business_id}
              onChange={handleBusinessName}
              variant="outlined"
              displayEmpty
              input={
                // eslint-disable-next-line react/jsx-wrap-multilines
                <OutlinedInput
                  classes={{ root: classes.customInput }}
                  style={{
                    marginRight: 15,
                    height: 32,
                    padding: "4px 8px",
                    fontSize: "14px",
                    borderColor: "black", // base border color
                  }}
                />
              }
            >
              <MenuItem aria-label="None" value="">
                All business names
              </MenuItem>

              {businessList &&
                businessList?.map((item) => (
                  <MenuItem key={item.business_id} value={item.business_id}>
                    {item.business_name}
                  </MenuItem>
                ))}
            </Select>
          ) : (
            <Typography className={classes.BreakDownText}>
              {`Breakdown of ${
                eventSummary && eventSummary[activeTab]?.event_group_name
              }`}
            </Typography>
          )}
          <Select
            value={dateRange}
            variant="outlined"
            input={
              <OutlinedInput
                classes={{ root: classes.customInput }}
                style={{
                  height: 32,
                  padding: "4px 8px",
                  fontSize: "14px",
                  borderColor: "black", // base border color
                }}
              />
            }
            onChange={(e) => handleDateRange(e)}
          >
            <MenuItem aria-label="None" value={0.25}>
              Last 7 Days
            </MenuItem>
            <MenuItem aria-label="None" value={1}>
              Last 30 Days
            </MenuItem>
            <MenuItem aria-label="None" value={6}>
              Last 6 Months
            </MenuItem>
            <MenuItem aria-label="None" value={12}>
              Last 12 Months
            </MenuItem>
          </Select>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end" // push everything to the right
          sx={{ width: "100%" }}
        >
          {!isBreakdownReport ? (
            <Box display="flex" alignItems="center" marginBottom={5} gap={1}>
              {/* <Typography variant="h6" sx={{ fontWeight: 400 }}>
                Download PDF Summary
              </Typography>
              <Box component="span" sx={{ width: 20, height: 20 }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 20h14v-2H5v2zm7-18l-7 7h4v6h6v-6h4l-7-7z" />
                </svg>
              </Box> */}
            </Box>
          ) : null}
        </Box>

        <Paper>
          <Route
            path="/"
            render={() => (
              <>
                <Tabs
                  value={activeTab}
                  indicatorColor="primary"
                  textColor="primary"
                  onChange={handleChange}
                  scrollButtons="off"
                  variant="fullWidth"
                  aria-label="event tabs"
                  style={{
                    justifyContent: "flex-start",
                    textAlign: "left",
                    display: isBreakdownReport ? "none" : "block",
                  }}
                >
                  {isLoading
                    ? [...Array(4)].map((i) => (
                        // eslint-disable-next-line react/jsx-indent
                        <Tab
                          key={i}
                          label={
                            <Skeleton
                              variant="text"
                              width={100}
                              height={24}
                              animation="wave"
                            />
                          }
                          disabled
                        />
                      ))
                    : eventSummary &&
                      eventSummary.map((tab, index) => (
                        <Tab
                          key={tab.event_group_code}
                          {...a11yProps(index)}
                          label={
                            <Box
                              display="flex"
                              alignItems="center"
                              width="100%"
                              px={2}
                              justifyContent="space-between"
                            >
                              <Box>{tab.event_group_name}</Box>
                              <Badge
                                badgeContent={tab.total}
                                color="error"
                                max={999}
                              />
                            </Box>
                          }
                          style={{
                            justifyContent: "flex-start",
                            minHeight: 48,
                          }}
                        />
                      ))}
                </Tabs>

                <Box p={3}>
                  {isEventDetailLoading || (isBreakdownReport && isLoading) ? (
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      py={8}
                    >
                      <CircularProgress color="primary" />
                      <Typography variant="body2" style={{ marginTop: 16 }}>
                        Loading data...
                      </Typography>
                    </Box>
                  ) : (
                    eventSummary &&
                    eventSummary.map((item, index) => (
                      <TabPanel
                        key={item.event_group_code}
                        value={activeTab}
                        index={index}
                      >
                        {Array.isArray(eventDetail) && eventDetail.length ? (
                          <>
                            <Box style={{ padding: "32px" }}>
                              <Box
                                display="flex"
                                flexDirection="row"
                                alignItems="center"
                                justifyContent="center"
                              >
                                <Typography
                                  style={{ fontSize: "12px", padding: 0 }}
                                >
                                  <Checkbox
                                    checked
                                    disableRipple
                                    style={{ color: "black" }}
                                    inputProps={{
                                      "aria-label": "borderless checkbox",
                                    }}
                                  />
                                  {`${eventDetail[0].service_type_name} only`}
                                </Typography>

                                <Box ml={2}>
                                  <Typography style={{ fontSize: "12px" }}>
                                    {`No. ${item.event_group_name}`}
                                  </Typography>
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {eventDetail[0].total}
                                  </span>
                                </Box>

                                <Box p={2} flexGrow={1}>
                                  <HorizontalProgress
                                    id="my-bar"
                                    value={100}
                                    color="#ffce00"
                                    duration={1200}
                                  />
                                </Box>
                              </Box>

                              <Typography
                                style={{ fontSize: "12px", paddingBottom: 0 }}
                              >
                                The number of digital contacts people have made,
                                including emails and web enquiry forms.
                              </Typography>
                              <Typography
                                style={{
                                  fontStyle: "italic",
                                  color: "gray",
                                  fontSize: "12px",
                                }}
                              >
                                * Data includes statistics and reporting from
                                Apple products that have been integrated with
                                Yellow, where this data has been received from
                                Apple.
                              </Typography>
                              <Box className={classes.flexBox} marginTop={6}>
                                <Typography style={{ fontWeight: "bold" }}>
                                  {`${item.event_group_name
                                    .toLowerCase()
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" ")} ${dayjs(
                                    selectedDate.start_date
                                  ).format("DD/MM/YYYY")} to ${dayjs(
                                    selectedDate.end_date
                                  ).format("DD/MM//YYYY")}`}
                                </Typography>
                                <Typography
                                  component="button"
                                  className={classes.downloadCsv}
                                  onClick={
                                    () =>
                                      handleDownloadCsv(
                                        eventDetail[0].counts,
                                        eventDetail[0].service_type_name,
                                        item.event_group_name
                                      )
                                    // eslint-disable-next-line react/jsx-curly-newline
                                  }
                                >
                                  Download CSV
                                </Typography>
                              </Box>
                            </Box>

                            {isBreakdownReport &&
                            eventSummary[activeTab]?.service_types[0]
                              ?.report_line_items ? (
                              // eslint-disable-next-line react/jsx-indent
                              <BreakDownBar
                                // eslint-disable-next-line react/jsx-indent-props
                                data={
                                  eventSummary[activeTab]?.service_types[0]
                                    ?.report_line_items
                                }
                                // eslint-disable-next-line react/jsx-closing-bracket-location
                              />
                            ) : (
                              <ReusableChart
                                data={eventDetail[0].counts}
                                serviceTypeName={
                                  eventDetail[0].service_type_name
                                }
                                scale={selectedDate?.scale || "daily"}
                              />
                            )}

                            <Box style={{ padding: "32px" }}>
                              <Box className={classes.flexBox} marginTop={6}>
                                {!isBreakdownReport ? (
                                  <Typography
                                    component="span"
                                    onClick={() => {
                                      params.set("isBreakdownReport", true);
                                      history.push({
                                        pathname: location.pathname,
                                        search: params.toString(),
                                      });
                                      setIsBreakdownReport(true);
                                    }}
                                    className={classes.breakdownButton}
                                  >
                                    {`View Breakdown of ${item.event_group_name
                                      .toLowerCase()
                                      .split(" ")
                                      .map(
                                        (word) =>
                                          word.charAt(0).toUpperCase() +
                                          word.slice(1)
                                      )
                                      .join(" ")}`}
                                  </Typography>
                                ) : (
                                  <Box />
                                )}
                                <Typography style={{ fontWeight: "bold" }}>
                                  <Typography
                                    component="span"
                                    className={classes.volatile}
                                  />{" "}
                                  Data is still being calculated
                                </Typography>
                              </Box>
                            </Box>
                          </>
                        ) : (
                          <Fade in={visible} timeout={800}>
                            <Box
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                              justifyContent="center"
                              py={6}
                              bgcolor="white"
                              color="textPrimary"
                            >
                              <img
                                width="216"
                                src={noResultImg}
                                alt="No results"
                              />
                              <Typography
                                variant="h6"
                                style={{ fontWeight: 600 }}
                                gutterBottom
                              >
                                Oops, no reporting data...
                              </Typography>
                              <Typography variant="body2" align="center">
                                please check back later, or call{" "}
                                <Box
                                  component="span"
                                  style={{ fontWeight: 500 }}
                                >
                                  1800 670 722
                                </Box>
                              </Typography>
                            </Box>
                          </Fade>
                        )}
                      </TabPanel>
                    ))
                  )}
                </Box>
              </>
            )}
          />
        </Paper>
      </>
    </MainContent>
  );
};

export default withGatewayApi(withRouter(Reporting));
